var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92085 2.92085C3.03025 2.81146 3.17862 2.75 3.33333 2.75H6C6.41421 2.75 6.75 2.41421 6.75 2C6.75 1.58579 6.41421 1.25 6 1.25H3.33333C2.7808 1.25 2.2509 1.46949 1.86019 1.86019C1.46949 2.2509 1.25 2.7808 1.25 3.33333V12.6667C1.25 13.2192 1.46949 13.7491 1.86019 14.1398C2.25089 14.5305 2.7808 14.75 3.33333 14.75H6C6.41421 14.75 6.75 14.4142 6.75 14C6.75 13.5858 6.41421 13.25 6 13.25H3.33333C3.17862 13.25 3.03025 13.1885 2.92085 13.0791C2.81146 12.9697 2.75 12.8214 2.75 12.6667V3.33333C2.75 3.17862 2.81146 3.03025 2.92085 2.92085ZM10.1363 4.13634C10.4292 3.84345 10.9041 3.84345 11.197 4.13634L14.5253 7.4647C14.5458 7.48476 14.5651 7.50599 14.5831 7.52827C14.6179 7.57123 14.6473 7.61715 14.6713 7.66509C14.7216 7.7659 14.75 7.87964 14.75 8C14.75 8.11792 14.7228 8.22948 14.6743 8.32875C14.6485 8.38157 14.6162 8.432 14.5773 8.4788C14.5611 8.49831 14.5439 8.51698 14.5259 8.53474L11.197 11.8637C10.9041 12.1566 10.4292 12.1566 10.1363 11.8637C9.8434 11.5708 9.8434 11.0959 10.1363 10.803L12.1893 8.75H6C5.58579 8.75 5.25 8.41421 5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H12.1893L10.1363 5.197C9.8434 4.90411 9.8434 4.42923 10.1363 4.13634Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.49bc90d78eb0e89dec674768a88ef667.svg";
export { ForwardRef as ReactComponent };